import * as i0 from '@angular/core';
import { Directive, Input, HostBinding, HostListener, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Base button class that both anchor and button directives can extend
 * to include all shared functionality.
 */
class _BaseButtonDirective {
    constructor() {
        this.color = 'primary';
        this.size = 'default';
        this.outline = false;
        // All styles need .btn set
        this._defaultClass = true;
    }
    get classes() {
        const classes = [];
        const color = this.color || 'primary';
        if (this.outline) {
            classes.push(`btn-outline-${color}`);
        }
        else {
            classes.push(`btn-${color}`);
        }
        if (this.size !== 'default') {
            classes.push(`btn-${this.size === 'large' ? 'lg' : 'sm'}`);
        }
        return classes.join(' ');
    }
}
_BaseButtonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: _BaseButtonDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
_BaseButtonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: _BaseButtonDirective, inputs: { color: "color", size: "size", outline: "outline" }, host: { properties: { "class.btn": "this._defaultClass", "class": "this.classes" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: _BaseButtonDirective, decorators: [{
            type: Directive
        }], propDecorators: { color: [{
                type: Input
            }], size: [{
                type: Input
            }], outline: [{
                type: Input
            }], _defaultClass: [{
                type: HostBinding,
                args: ['class.btn']
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }] } });
// <a> and <button> tags handle disabled attribute differently so we
// split the directives in two and have the specific logic for
// disabling either a button or anchor in each one.
/**
 * A directive that applies our button styles to any button or a tags.
 */
class ButtonDirective extends _BaseButtonDirective {
    constructor() {
        super(...arguments);
        this.disabled = false;
    }
}
ButtonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ButtonDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
ButtonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: ButtonDirective, selector: "button[psUiButton]", inputs: { disabled: "disabled" }, host: { properties: { "disabled": "this.disabled" } }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[psUiButton]',
                }]
        }], propDecorators: { disabled: [{
                type: Input
            }, {
                type: HostBinding
            }] } });
class ButtonAnchorDirective extends _BaseButtonDirective {
    constructor() {
        super(...arguments);
        this.disabled = false;
    }
    haltDisabledEvent(event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
ButtonAnchorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ButtonAnchorDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
ButtonAnchorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: ButtonAnchorDirective, selector: "a[psUiButton]", inputs: { disabled: "disabled" }, host: { listeners: { "click": "haltDisabledEvent($event)" }, properties: { "class.disabled": "this.disabled" } }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ButtonAnchorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'a[psUiButton]',
                }]
        }], propDecorators: { disabled: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.disabled']
            }], haltDisabledEvent: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class ButtonModule {
}
ButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ButtonModule, declarations: [ButtonDirective, ButtonAnchorDirective], imports: [CommonModule], exports: [ButtonDirective, ButtonAnchorDirective] });
ButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ButtonModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: ButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ButtonDirective, ButtonAnchorDirective],
                    exports: [ButtonDirective, ButtonAnchorDirective],
                    imports: [CommonModule],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonAnchorDirective, ButtonDirective, ButtonModule, _BaseButtonDirective };
